import { Icon } from '@bonanza-social/moonlight';
import AccountLink, { AccountLinkProps } from '../AccountLink/AccountLink';
import { selectBiometricsType } from '@bonanza-social/auth/state';
import { useMemo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';

function LinksMenu() {
  const biometryType = useSelector(selectBiometricsType);

  const links = useMemo<Array<AccountLinkProps | undefined>>(
    () => [
      {
        labelKey: 'link_MyProfile',
        navigateTo: 'MyProfile',
        icon: <Icon name="accountCircle" />,
        key: 'acc-det',
      },
      {
        labelKey: 'link_2fa',
        navigateTo: 'TwoFactorAuthentication',
        icon: <Icon name="lock" />,
        key: 'acc-mfa',
      },
      biometryType && {
        labelKey: 'link_biometricLogin',
        navigateTo: 'BiometricLogin',
        icon: (
          <Icon
            name="fingerprint"
            gradient="accentBackground"
            width="space-600"
            height="space-600"
          />
        ),
        key: 'acc-bio',
      },
      {
        labelKey: 'link_TransactionHistory',
        navigateTo: 'TransactionHistory',
        icon: <Icon name="paid" />,
        key: 'acc-his',
      },
      {
        labelKey: 'link_GamingTransactions',
        navigateTo: 'GamingHistory',
        icon: (
          <Icon
            name="slotsDark"
            gradient="accentBackground"
            width="space-600"
            height="space-600"
          />
        ),
        key: 'acc-tra',
      },
      {
        labelKey: 'link_CoinsGamingTransactions',
        navigateTo: 'CoinsGamingTransactions',
        icon: (
          <Icon
            name="bonanzaCoin"
            gradient="accentBackground"
            width="space-600"
            height="space-600"
          />
        ),
        key: 'acc-bty-tra',
      },
      {
        labelKey: 'link_Sessions',
        navigateTo: 'SessionHistory',
        icon: <Icon name="timelapse" />,
        key: 'acc-ses',
      },
      {
        labelKey: 'link_ManageNotifications',
        navigateTo: 'Notifications',
        icon: (
          <Icon
            name="inboxBell"
            gradient="accentBackground"
            width="space-600"
            height="space-600"
          />
        ),
        key: 'acc-not',
      },
    ],
    [biometryType],
  );

  return links.map((link) => link && <AccountLink {...link} key={link.key} />);
}

export default LinksMenu;
